import request from '@/utils/request'
import uploadRequest from '@/utils/uploadRequest'

/**
 * 分润提现历史记录
 * @param {*} params token, userId
 * todo
 * @returns
 */
export const withdrawalHistory = params => {
  return request({
    method: 'post',
    url: '/mobile/withdrawal/history',
    data: params
  })
}
/**
 * 分润提现账户
 * @param {*} params token, userId
 * todo
 * @returns
 */
export const withdrawalAccount = params => {
  return request({
    method: 'post',
    url: '/mobile/withdrawal/account',
    data: params
  })
}
/**
 * 申请绑定提现卡
 * @param {*} params token, userId
 * todo
 * @returns
 */
export const addAccount = params => {
  return request({
    method: 'post',
    url: '/mobile/withdrawal/account/add',
    data: params
  })
}

/**
 * 上传证件照
 * @param {*} params token, userId
 * @returns
 */
export const uploadIdCard = (formData) => {
  return uploadRequest.post('/mobile/withdrawal/uploadIdCard', formData)
}

export const withdrawalSubmit = params => {
  return request({
    method: 'post',
    url: '/mobile/withdrawal/submit',
    data: params
  })
}
